var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6367 14.3174H9.63672V6.31738H7.63672V4.31738H11.6367V14.3174ZM16.6367 0.317383H2.63672C2.10629 0.317383 1.59758 0.528096 1.22251 0.903169C0.847432 1.27824 0.636719 1.78695 0.636719 2.31738V16.3174C0.636719 16.8478 0.847432 17.3565 1.22251 17.7316C1.59758 18.1067 2.10629 18.3174 2.63672 18.3174H16.6367C17.1672 18.3174 17.6759 18.1067 18.0509 17.7316C18.426 17.3565 18.6367 16.8478 18.6367 16.3174V2.31738C18.6367 1.78695 18.426 1.27824 18.0509 0.903169C17.6759 0.528096 17.1672 0.317383 16.6367 0.317383Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepOne);
export default __webpack_public_path__ + "static/media/step-one.6f1041f0e6c24034a95cdf3bb8b485aa.svg";
export { ForwardRef as ReactComponent };